import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { accountIdFormat, aeoRecommendationIdFormat } from "../ids";

export const DAYS_FOR_AEO_RECOMMENDATIONS = 7;

export enum AeoRecommendationPriority {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}
export const AeoRecommendationPrioritySchema = createEnum(
  AeoRecommendationPriority,
);

export enum AeoRecommendationCategory {
  COMPETITOR_INSIGHT = "competitor_insight",
  CONTENT_OPPORTUNITY = "content_opportunity",
  EARNED_MEDIA_ACTION = "earned_media_action",
  PRODUCT_IMPROVEMENT = "product_improvement",
  WINNING_STRATEGY = "winning_strategy",
}
export const AeoRecommendationCategorySchema = createEnum(
  AeoRecommendationCategory,
);

export enum AeoRecommendationFeedbackKind {
  POSITIVE = "positive",
  NEGATIVE = "negative",
}
export const AeoRecommendationFeedbackKindSchema = createEnum(
  AeoRecommendationFeedbackKind,
);

export const AeoRecommendationFeedbackSchema = z.object({
  kind: AeoRecommendationFeedbackKindSchema,
  comment: z.string().optional(),
});

const RecommendationContextSchema = z.object({
  promptIds: z.array(z.bigint()),
  competitors: z.array(z.string()),
  sources: z.array(z.string()),
});

const RecommendationReasoningSchema = z.object({
  reasoning: z.string(),
  primaryMetric: z.string(),
  trend: z.string().optional(),
  context: RecommendationContextSchema,
});

const aeoRecommendationSchema_ = z.object({
  id: aeoRecommendationIdFormat.schema,
  accountId: accountIdFormat.schema,
  title: z.string(),
  recommendedAction: z.string(),
  reasoning: RecommendationReasoningSchema,
  priority: AeoRecommendationPrioritySchema,
  category: AeoRecommendationCategorySchema,
  feedback: AeoRecommendationFeedbackSchema.optional(),
  createdAt: z.date(),
  dismissedAt: z.date().optional(),
});
export const AeoRecommendationSchema: z.ZodType<AeoRecommendation> =
  aeoRecommendationSchema_;
export interface AeoRecommendation
  extends z.infer<typeof aeoRecommendationSchema_> {}
